<h2 mat-dialog-title>Preview: {{ data.fileName }}</h2>
<mat-dialog-content>
  <div style="max-height: 400px; overflow: auto">
    <table class="preview-table">
      <thead>
        <tr>
          <th *ngFor="let header of data.previewData[0]">{{ header }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of data.previewData.slice(1)">
          <td *ngFor="let cell of row">{{ cell }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button [disabled]="data.viewOnly" mat-raised-button color="primary" (click)="dialogRef.close('upload')">
    Upload
  </button>
</mat-dialog-actions>
